export default "__VITE_ASSET__Fk9kXqp$__"